import { useMutation } from '@tanstack/react-query'

import { sendEmailAffReq } from '../affiliateService'

export const useSendAffiliateEmail = () => {
  return useMutation({
    mutationFn: (data: string) => sendEmailAffReq(data),
  })
}
